import {
    TaskData,
    TaskListQuery,
    TaskUpdateParams,
    TaskCreationParams,
    TaskStatus,
    TaskListResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api/task';

export class TaskApi {
    public static async find(params?: TaskListQuery): Promise<TaskData[]> {
        const res = await axios.get<any>(`${BASE_URL}`, { params });

        return res.data.tasks;
    }

    public static async findWithCount(params?: TaskListQuery): Promise<TaskListResponse> {
        const res = await axios.get<TaskListResponse>(`${BASE_URL}`, { params });

        return res.data;
    }

    public static async getById(taskId: string): Promise<TaskData> {
        const res = await axios.get<any>(`${BASE_URL}/${taskId}`);

        return res.data.task;
    }

    public static async create(task: TaskCreationParams): Promise<void> {
        await axios.post(`${BASE_URL}/`, { task });
    }

    public static async update(taskId: string, task: TaskUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${taskId}`, { task });
    }

    public static async updateStatus(taskId: string, status: TaskStatus): Promise<void> {
        await axios.put(`${BASE_URL}/${taskId}/status`, {
            task: {
                status,
            },
        });
    }

    public static async remove(taskId: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${taskId}`);
    }
}
